import React, {Component} from 'react';

import ReadyButton from '../../components/ReadyButton';
import AudioPlayer from '../../components/AudioPlayer';

import {no, nn, se, de} from './assets';

import strings from '../../strings';
import {getTestLanguage} from '../../constants/tests';

import  flowerblue from '../../assets/images/rapidNaming/se/stjerne_red-min.png'
import 	appleorange from '../../assets/images/rapidNaming/se/flower-blue.png'
import 	zebragreen from '../../assets/images/rapidNaming/se/bike-green.png'
import 	tablered from '../../assets/images/rapidNaming/se/moon_brown-min.png'
import 	womangrey from '../../assets/images/rapidNaming/se/kake_yellow-min.png'


class Intro extends Component {
	constructor(props) {
		super(props);

		switch (strings.getLanguage()) {
			case 'nn':
				this.assets = nn;
				break;
			case 'se':
				this.assets = se;
				break;
			case 'de':
				this.assets = de;
				break;
			case 'no':
			default:
				this.assets = no;
				break;
		}

		this.state = {
			stepData: {},
			hasCorrectWordsGiven: false,
			step: 0,
		};
	}

	componentWillReceiveProps(newProps) {
		if (this.props.currentStep !== newProps.currentStep) {
			this.setState({step: newProps.currentStep});
		}
		if (this.props.stepData !== newProps.stepData) {
			const hasCorrectWordsGiven =
				newProps.stepData.hasOwnProperty('correctWordsGiven') &&
				newProps.stepData.correctWordsGiven;

			if (!this.state.hasCorrectWordsGiven && hasCorrectWordsGiven) {
				this.setState({
					hasCorrectWordsGiven,
				});
				this.playSecondClip();
			}
		}
	}

	playSecondClip = () => {
		if (this.audio2) this.audio2.handleStartPlayer();
	};

	render() {
		const step = this.state.step;
		return (
			<div className="RapidNamingIntro">
				{step === 0 && (
					<>
						<p>
							<AudioPlayer
								autoplay
								inline
								src={this.assets.intro1}
							/>
							{strings.rn_intro1}
						</p>
						<ReadyButton onReadyChange={this.props.setReady} />
					</>
				)}
				{step === 1 && (
							<>
								<p>
									<AudioPlayer
										autoplay
										inline
										src={this.assets.intro4}
									/>
									{strings.intro4}
								</p>
								<div className="items">
									<img
										className="image"
										src={flowerblue}
										alt=""
									/>
									<img
										className="image"
										src={appleorange}
										alt=""
									/>
									<img
										className="image"
										src={zebragreen}
										alt=""
									/>
									<img
										className="image"
										src={tablered}
										alt=""
									/>
									<img
										className="image"
										src={womangrey}
										alt=""
									/>
								</div>
							</>
						)}
				 {step === 2 && (
					<>
						<p>
							<AudioPlayer
								ref={(node) => (this.audio2 = node)}
								inline
								autoplay
								src={this.assets.intro5}
							/>
							{strings.rn_intro5}
						</p>
						<ReadyButton onReadyChange={this.props.setReady} />
					</>
				)} 
			</div>
		);
	}
}

export default Intro;
